import { call, put, delay, select } from 'redux-saga/effects';
import type { Action } from 'redux-actions';
import { reloadStashStream } from '../actions';
import { getCurrentFolderId, getCurrentSubfolderId } from '../selectors';
import { uploadFile } from '../../redux/uploads/actions';
import type { UploadFilePayload } from '../../redux/uploads/types';

export function* uploadFileHandler(payload: UploadFilePayload) {
  yield put(
    uploadFile({
      ...payload,
      onSuccess: function* () {
        yield delay(1000); // wait arbitrary 1s for stash to update
        yield put(reloadStashStream());
      },
    })
  );
}

function* uploadFileSaga({ payload }: Action<UploadFilePayload>) {
  const folderId: ReturnType<typeof getCurrentFolderId> =
    yield select(getCurrentFolderId);
  const subfolderId: ReturnType<typeof getCurrentSubfolderId> =
    yield select(getCurrentSubfolderId);

  yield call(uploadFileHandler, {
    ...payload,
    folderId:
      payload.folderId ?? subfolderId ?? folderId,
  });
}

export default uploadFileSaga;
